import { AllowedFileExtensionsResponse } from '@shared/models/shared.model';
import { Observable } from 'rxjs';

export abstract class AllowedFileExtensionsAdapter {
  abstract loadAllowedFileExtensions(contextId: string): Observable<AllowedFileExtensionsResponse>
}